import $ from 'jquery';
import getCookie from './getCookie';

function banner(el) {
    const bannerCookie = getCookie('banner');

    if (bannerCookie === '0') {
        $(el).hide();
    } else {
        $(el).show();
    }

    $(el).find('.banner__close').click(function() {
        document.cookie = 'banner=0; path=/';
        $(el).hide();
    });
}

export default banner;
